import React, { useState } from "react";
import MessageActions from "./MessageActions";
import MessageReactions from "./MessageReactions";
import SeenStatus from "./SeenStatus";
import ReplyPreview from "./ReplyPreview";

function MessageItem({
  message,
  isMe,
  isGroup,
  onDelete,
  onEdit,
  onReact,
  onReply,
  onImageClick,
}) {
  const [previewImg, setPreviewImg] = useState(null);

  if (!message) return null;

  const handleDelete = () => {
    if (typeof onDelete === "function") {
      onDelete(message._id);
    }
  };

  const handleReact = (emoji) => {
    if (typeof onReact === "function") {
      onReact(message._id, emoji);
    }
  };

  /* ================= DELETED ================= */

  if (message.isDeleted) {
    return (
      <div className={`message-row ${isMe ? "me" : "other"}`}>
        <div
          className="message-bubble"
          style={{
            opacity: 0.7,
            background: "#f1f3f5",
            border: "1px dashed #d0d5dd",
          }}
        >
          <div
            style={{
              fontSize: "13px",
              fontStyle: "italic",
            }}
          >
            This message was deleted
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {previewImg && (
        <div className="image-viewer">
          <div className="image-viewer-content">
            <img src={previewImg} alt="preview" />

            <div className="image-actions">
              <a href={previewImg} download className="btn btn-primary">
                Download
              </a>

              <button
                className="btn btn-danger"
                onClick={() => setPreviewImg(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`message-row ${isMe ? "me" : "other"}`}>
        <div className="message-bubble">
          {/* ACTIONS */}
          <div className="message-actions">
            <MessageActions
              isMe={isMe}
              onDelete={handleDelete}
              onEdit={() => onEdit(message)}
              onReply={() => onReply(message)}
              onReact={handleReact}
            />
          </div>

          {/* GROUP NAME */}
          {isGroup && !isMe && message.senderId?.name && (
            <div className="sender-name">{message.senderId.name}</div>
          )}

          {/* REPLY */}
          {message.replyTo && (
            <div
              style={{
                background: "rgba(0,0,0,0.05)",
                padding: "10px",
                borderRadius: "12px",
                marginBottom: "10px",
                borderLeft: "3px solid #ff512f",
              }}
            >
              <ReplyPreview reply={message.replyTo} />
            </div>
          )}

          {/* ================= BODY ================= */}

          <div className="message-text">
            {message.type === "text" && <div>{message.text}</div>}

            {message.type === "image" && (
              <img
                src={message.imageUrl || message.fileUrl}
                alt="chat-img"
                className="message-image"
                onClick={() =>
                  onImageClick(message.imageUrl || message.fileUrl)
                }
              />
            )}

            {message.type === "video" && (
              <video
                controls
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  marginTop: "8px",
                }}
              >
                <source src={message.videoUrl || message.fileUrl} />
              </video>
            )}

            {message.type === "audio" && (
              <audio controls className="message-audio">
                <source src={message.audioUrl || message.fileUrl} />
              </audio>
            )}

            {message.type === "file" && (
              <a
                href={message.fileUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-light border mt-2"
              >
                📄 Download File
              </a>
            )}
          </div>

          {/* TIME */}
          <div className="message-time">
            {new Date(message.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}

            {message.isEdited && <span className="ms-1">(edited)</span>}

            {isMe && (
              <span className="ms-2">
                <SeenStatus
                  seenBy={message.seenBy}
                  deliveredTo={message.deliveredTo}
                />
              </span>
            )}
          </div>

          {/* REACTIONS */}
          {message.reactions?.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <MessageReactions
                reactions={message.reactions}
                onReact={handleReact}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MessageItem;
